module.exports = __webpack_public_path__ + "img/introduccion.83de662d.png";